var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _circle, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCapa12(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.4039 16.7479C44.4653 19.1946 45.0763 21.8825 45.1335 24.7056C45.1364 24.8511 45.1382 24.9965 45.1382 25.1429C45.1382 34.8406 38.6043 43.0131 29.6997 45.4965C27.8893 46.0014 25.9813 46.2726 24.0094 46.2726C22.4365 46.2726 20.9039 46.1 19.4295 45.7743C11.6905 44.0633 5.54696 38.1103 3.56105 30.4792V30.4783C3.11715 28.7739 2.88062 26.9871 2.88062 25.1428C2.88062 23.9828 2.97446 22.8443 3.15465 21.7351",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.291 7.55916C15.6442 5.31947 19.6745 4.0141 24.0094 4.0141C26.2102 4.0141 28.3322 4.35197 30.3265 4.97513C32.1257 5.53829 33.8215 6.33601 35.3785 7.33172",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6997 45.4965C27.8893 46.0014 25.9813 46.2727 24.0094 46.2727C22.4365 46.2727 20.9039 46.1 19.4295 45.7743L18.4487 40.8321L14.1569 33.7247L3.56105 30.4793V30.4783C3.11715 28.7739 2.88062 26.9871 2.88062 25.1428C2.88062 23.9829 2.97446 22.8444 3.15465 21.7351",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3445 16.9375L17.9005 15.5775C18.9864 15.3119 20.0797 15.9821 20.3369 17.0697L21.2688 21.0172C21.6226 22.5131 21.4715 24.0842 20.839 25.4855L17.5851 32.6961L18.4993 36.239L25.128 34.7665C26.7 34.4173 28.319 35.1081 29.1542 36.484C29.3325 36.7777 29.4687 37.0931 29.5606 37.4216C29.6526 37.7491 29.6996 38.0898 29.6996 38.4333V42.15",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1337 24.7051L38.4996 23.7039C36.9775 23.4742 35.7428 22.3517 35.3695 20.8584L33.3572 12.8095L31.0289 10.9292C30.203 10.2622 29.7823 9.21443 29.9175 8.16152L30.3268 4.97571",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.297 7.69201C47.297 12.9775 41.3323 19.2596 41.3323 19.2596C41.3323 19.2596 35.3677 12.9775 35.3677 7.69201C35.3677 4.39782 38.0381 1.72736 41.3323 1.72736C44.6265 1.72736 47.297 4.39782 47.297 7.69201Z",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3323 11.1227C39.4406 11.1227 37.9016 9.58367 37.9016 7.69198C37.9016 5.80029 39.4406 4.26129 41.3323 4.26129C43.224 4.26129 44.7629 5.80029 44.7629 7.69198C44.7629 9.58367 43.224 11.1227 41.3323 11.1227Z",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6324 14.7941C12.6324 20.0797 6.66778 26.3617 6.66778 26.3617C6.66778 26.3617 0.703125 20.0797 0.703125 14.7941C0.703125 11.4999 3.37359 8.82947 6.66778 8.82947C9.96197 8.82947 12.6324 11.4999 12.6324 14.7941Z",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66775 18.2248C4.77606 18.2248 3.23706 16.6858 3.23706 14.7941C3.23706 12.9024 4.77606 11.3634 6.66775 11.3634C8.55944 11.3634 10.0983 12.9024 10.0983 14.7941C10.0983 16.6858 8.55944 18.2248 6.66775 18.2248Z",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6501 9.5791L27.5319 11.5376C28.0738 12.1016 28.4302 12.818 28.5531 13.5905L28.7521 14.8403",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.3757,
    cy: 18.5133,
    r: 0.703125,
    fill: "#102E7A"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6695 29.6321L32.1407 35.6104C32.1904 36.242 32.7265 36.7238 33.3598 36.7062L34.3635 36.6783C35.0391 36.6594 35.5634 36.0823 35.5174 35.408L35.3055 32.3029C35.2542 31.5512 34.9132 30.8486 34.3545 30.3432L32.8996 29.0271C32.4048 28.5795 31.6171 28.9669 31.6695 29.6321Z",
    stroke: "#102E7A",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapa12);
export default __webpack_public_path__ + "static/media/Capa_1 (2).154bbc9a34e30ddb92ca820ce187beba.svg";
export { ForwardRef as ReactComponent };